import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Output,
	Input,
	ChangeDetectorRef,
} from '@angular/core';
import { Core } from '../core.component';

@Component({
	selector: 'prop-body',
	templateUrl: 'body.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BodyComponent extends Core {
	@Input('value')
	question: any;
	@Input('color')
	color: string = 'dark';
	@Output()
	textChange: EventEmitter<any> = new EventEmitter();

	constructor(private ref: ChangeDetectorRef) {
		super();
	}

	getClass() {
		let obj = {};
		obj[this.color] = true;
		return obj;
	}

	// Setter for on change event
	setChangeEvent(value: any) {
		this.textChange.emit(value);
	}

	// Getter for on change event
	getChangeEvent() {
		return this.textChange;
	}
}
